export default "__VITE_ASSET__CEus1QYv__"